var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('navBar'),(_vm.showLoader)?_c('Loader',{on:{"destroy-loader":function($event){_vm.showLoader=false}}}):_vm._e(),_c('transition',{attrs:{"name":"slide-fade","mode":"out-in"}},[(_vm.$route.name == 'PerfilDeUsuario'
        || _vm.$route.name == 'evento' || _vm.$route.name == 'eventos'
        || _vm.$route.name == 'revista' || _vm.$route.name == 'articulos'
        || _vm.$route.name == 'soyMedico')?_c('router-view'):_c('client-only',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }